import { MIN_PASSWORD_LENGTH } from "../lib/common/constants";

export const MESSAGES_MAP: {
    [keys: string]: string;
} = {
    // Email / Signup
    "auth/email-already-in-use": "Email already in use",
    "auth/invalid-email": "Invalid email address",

    // Password
    "auth/weak-password": "Password must be at least 6 characters",
    "auth/wrong-password": "Incorrect password",

    // Login / User
    "auth/user-not-found": "No account found with this email",
    "auth/user-disabled": "This account has been disabled",

    // Reset / Action links
    "auth/expired-action-code": "This link has expired",
    "auth/invalid-action-code": "This link is invalid or already used",

    // Rate limits / network
    "auth/too-many-requests": "Too many attempts. Please try again later",
    "auth/network-request-failed": "Network error. Check your connection",

    // GENERIC ERROR
    "generic-error": "Something went wrong. Please try again.",
};

export const getAuthErrorMessage = (error: any): string => {
    if (!error) {
        return MESSAGES_MAP["generic-error"];
    }

    if (error.code === "auth/weak-password") {
        return MESSAGES_MAP["auth/weak-password"];
    }

    return MESSAGES_MAP[error.code] ?? MESSAGES_MAP["generic-error"];
};

export const validatePasswordLength = (password: string): string | null => {
    if (!password || password.length < MIN_PASSWORD_LENGTH) {
        return MESSAGES_MAP["auth/weak-password"];
    }

    return null;
};
